import {
  systemConstants,
  EMPTY_STRING,
  DEFAULT_CONFIRMATION_MODAL_REDUX,
} from "../../constants";
import { updateObject } from "../../shared/utility";
import { SIDEBAR_BUTTONS } from "../../constants";

const defaultTab = Object.values(SIDEBAR_BUTTONS).find((route) => {
  return (
    route
      .toLowerCase()
      .includes(window.location.pathname.toLowerCase().slice(1, 4)) && route
  );
});

const initialState = {
  spinnerArray: [],
  isLoading: false,
  isRedirect: false,
  pageToRedirect: EMPTY_STRING,
  isSidebarOpen: true,
  isNestedSidebarOpen: true,
  isServerSearchLoading: false,
  confirmationModalRedux: DEFAULT_CONFIRMATION_MODAL_REDUX,
  activeSidebarBtn: defaultTab ? defaultTab : SIDEBAR_BUTTONS.DASHBOARD,
  draggableNotification: {
    isVisible: false,
    messages: [],
    jobId: null,
  },
};

//-------Export System Reducer
export const system = (state = initialState, action) => {
  switch (action.type) {
    //-------Activate Spinner case
    case systemConstants.SPINNER_ACTIVATE:
      return updateObject(state, {
        isLoading: true,
        spinnerArray: [...state.spinnerArray, action.data],
      });
    //-------Deactivate Spinner case
    case systemConstants.SPINNER_DEACTIVATE:
      return updateObject(state, {
        isLoading: false,
        spinnerArray: state.spinnerArray.filter((p) => p !== action.data),
      });
    case systemConstants.DRAGGABLE_NOTIFICATION_ACTIVATE:
      let messages = [...state.draggableNotification.messages, action.data];
      messages = Array.from(
        new Map(messages.map((item) => [item.id, item])).values()
      );
      return updateObject(state, {
        draggableNotification: {
          isVisible: true,
          messages,
        },
      });
    case systemConstants.DRAGGABLE_NOTIFICATION_DEACTIVATE:
      return updateObject(state, {
        draggableNotification: {
          isVisible: false,
          messages: state.draggableNotification.messages.filter(
            (message) => message?.spinnerType !== action.data.spinnerType
          ),
        },
      });
    // Toggle Sidebar
    case systemConstants.TOGGLE_SIDEBAR:
      return updateObject(state, {
        isSidebarOpen: !state.isSidebarOpen,
      });
    case systemConstants.TOGGLE_NESTED_SIDEBAR:
      return updateObject(state, {
        isNestedSidebarOpen: !state.isNestedSidebarOpen,
      });
    case systemConstants.SET_ACTIVE_SIDEBAR_BTN:
      return updateObject(state, {
        activeSidebarBtn: action.data,
      });
    //-------User added successfully
    case systemConstants.TOGGLE_REDIRECT_PAGE:
      return updateObject(state, {
        pageToRedirect: action.data,
        isRedirect: !state.isRedirect,
      });
    case systemConstants.SET_IS_SERVER_SEARCH_LOADING:
      return updateObject(state, {
        isServerSearchLoading: action.data,
      });
    case systemConstants.SET_CONFIRMATION_MODAL_REDUX:
      return updateObject(state, {
        confirmationModalRedux: action.data,
      });
    //-------Default State
    default:
      return state;
  }
};
